import React, { Component } from "react";

class ChartItem extends Component {
  detailsRef = React.createRef();

  componentDidUpdate(prevProps) {
    if (!prevProps.editing && this.props.editing) {
      this.detailsRef.current?.removeAttribute("open");
    }
  }

  handleClickSelect = () => {
    const { editing, onClick } = this.props;
    if (!editing) return;
    onClick();
  };

  render() {
    const {
      chart,
      editing,
      selected,
      onEdit,
      onDelete,
      referencias = [],
      resumos = [],
      cliente,
    } = this.props;

    const referenciasDoGrafico = referencias.filter(
      (ref) => ref.grafico === chart.id
    );

    const resumosDoGrafico = resumos.filter(
      (res) => res.grafico === chart.id
    );

    return (
      <div
        className={`
          chart-item
          ${editing ? "chart-item--editing" : ""}
          ${selected ? "chart-item--selected" : ""}
        `}
        style={{ cursor: editing ? "pointer" : "default", margin: "10px 0px", }}
      >
        <details
          ref={this.detailsRef}
          style={{ borderTop: "none" }}
          className="hdv-relatorio-chart"
          open={false}
        >
          <summary
            onClick={(e) => {
              if (editing) {
                e.preventDefault();
                e.stopPropagation();
                this.handleClickSelect();
              }
            }}
            style={{
              backgroundColor: "#eeeeee",
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <i
                  style={{ fontSize: "20px" }}
                  className={
                    chart.tipo_grafico.value === "linha"
                      ? "fa fa-chart-line mr-1"
                      : "fa fa-chart-bar mr-1"
                  }
                />
                <span>{chart.descricao}</span>
              </div>

              {cliente ? null : (
                <div className="row" style={{ marginRight: "6px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <button
                      onClick={onEdit}
                      disabled={editing}
                      style={{
                        color: "#333",
                        width: "60px",
                        border: "1px solid #cacaca",
                      }}
                      className="hdv-chart-edit hdv-automacao-delete-button d-flex align-items-center"
                    >
                      <i className="fa fa-pen" style={{ fontSize: "22px" }} />
                      Editar
                    </button>

                    <button
                      onClick={onDelete}
                      disabled={editing}
                      style={{ color: "#fff", width: "65px" }}
                      className="hdv-chart-close hdv-btn-red hdv-automacao-delete-button d-flex align-items-center"
                    >
                      <i className="fa fa-times" style={{ fontSize: "22px" }} />
                      Deletar
                    </button>
                  </div>
                </div>
              )}
            </div>
          </summary>

          <div style={{ display: "flex" }}>
            <div id="hdv-content">
              <strong>Configurações</strong>
              <span>Descrição: {chart.descricao}</span>
              <span>
                Parâmetro: {chart?.campo_customizado?.descricao} (
                {chart?.campo_customizado?.identificacao})
              </span>
              <span>Tipo: {chart.tipo_grafico.label}</span>
              <span style={{ display: "flex", alignItems: "center" }}>
                Cor:
                <div
                  style={{
                    width: "16px",
                    height: "16px",
                    backgroundColor: chart.cor_linha,
                    margin: "0 4px",
                    borderRadius: "20px",
                  }}
                />
              </span>
            </div>

            {referenciasDoGrafico.length > 0 && (
              <div id="hdv-content">
                <strong>Referências</strong>
                {referenciasDoGrafico.map((ref, index) => (
                  <span
                    key={index}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <div
                      style={{
                        width: "16px",
                        height: "16px",
                        backgroundColor: ref?.cor_linha,
                        margin: "0 4px",
                        borderRadius: "20px",
                      }}
                    />
                    <span>{ref?.descricao}</span>
                  </span>
                ))}
              </div>
            )}

            {resumosDoGrafico.length > 0 && (
              <div id="hdv-content">
                <strong>Resumos</strong>
                {resumosDoGrafico.map((res, index) => (
                  <span
                    key={index}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    {res?.icone && (
                      <i
                        className={res.icone.value}
                        style={{ fontSize: "24px" }}
                      />
                    )}
                    <span>{res?.descricao}</span>
                  </span>
                ))}
              </div>
            )}
          </div>
        </details>
      </div>
    );
  }
}

export default ChartItem;
